import type { CURVE_FORMULA_FIELDS } from "@brewbase/lib";

/** What each number a formula can read off a calibration curve means. */
export const CURVE_FIELD_LABELS: Record<(typeof CURVE_FORMULA_FIELDS)[number], string> = {
  slope: "Slope",
  intercept: "Intercept",
  r_squared: "R² (absent when not recorded)",
  rt_min: "Retention time from (min)",
  rt_max: "Retention time to (min)",
};
